function ValidateSimHot (simNumber) {//source: HOT's website. Input: MUST be a string since the number overflows JS's numbers.
	//This version allow the user to skip 8997207 or to include it.
	if (!simNumber) return false;

	simNumber = simNumber.replace(/\D/g, '');//remove all non-digits

	//if it's 12 or 19 digits, it might be correct.
	if(simNumber.length!=19 && simNumber.length!=12) return false;
	
	if (simNumber.length==19 && simNumber.indexOf('8997207')!==0) return false;
	else if (simNumber.length==12) simNumber = '8997207' + simNumber;

	var startIndex = 0;
	var test = 0;

	for (var index = startIndex; index < 19; index++) {
		var charIndex = index + simNumber.length - 19;
		var dig = parseInt(simNumber.charAt(charIndex), 10);
		var mul = parseInt(((index % 2) + 1) * dig, 10) + '';
		//mul.split('').forEach(function(val){test +=parseInt(val,10)});
		for (var i = 0; i < mul.length; i++) {
			test += parseInt(mul.charAt(i), 10);
			}
		}
	return test % 10 == 0;
	}

module.exports=ValidateSimHot;
